/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAllServiceProviders200ResponseServiceProvidersInner } from './GetAllServiceProviders200ResponseServiceProvidersInner';
import {
    GetAllServiceProviders200ResponseServiceProvidersInnerFromJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerFromJSONTyped,
    GetAllServiceProviders200ResponseServiceProvidersInnerToJSON,
    GetAllServiceProviders200ResponseServiceProvidersInnerToJSONTyped,
} from './GetAllServiceProviders200ResponseServiceProvidersInner';

/**
 * Successful response
 * @export
 * @interface GetAllServiceProviders200Response
 */
export interface GetAllServiceProviders200Response {
    /**
     * 
     */
    serviceProviders?: Array<GetAllServiceProviders200ResponseServiceProvidersInner>;
}

/**
 * Check if a given object implements the GetAllServiceProviders200Response interface.
 */
export function instanceOfGetAllServiceProviders200Response(value: object): value is GetAllServiceProviders200Response {
    return true;
}

export function GetAllServiceProviders200ResponseFromJSON(json: any): GetAllServiceProviders200Response {
    return GetAllServiceProviders200ResponseFromJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllServiceProviders200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceProviders': json['serviceProviders'] == null ? undefined : ((json['serviceProviders'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerFromJSON)),
    };
}

export function GetAllServiceProviders200ResponseToJSON(json: any): GetAllServiceProviders200Response {
    return GetAllServiceProviders200ResponseToJSONTyped(json, false);
}

export function GetAllServiceProviders200ResponseToJSONTyped(value?: GetAllServiceProviders200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceProviders': value['serviceProviders'] == null ? undefined : ((value['serviceProviders'] as Array<any>).map(GetAllServiceProviders200ResponseServiceProvidersInnerToJSON)),
    };
}

